export const portfolioRiskStatsQuery = `
  query PortfolioRiskStats(
    $businessCentralId: String!
    $isic: [String!]!
    $countries: [String!]!
    $physicalRiskLevels: [GqlRiskBandLevel!]!
    $dependencyLevels: [GqlRiskBandLevel!]!
    $impactLevels: [GqlRiskBandLevel!]!
    $sonLevels: [GqlSonBandLevel!]!
    $at: DateTime
  ) {
    organisation(businessCentralId: $businessCentralId, at: $at) {
      portfolioRiskStats(
        isic: $isic
        countries: $countries
        physicalRiskLevels: $physicalRiskLevels
        dependencyLevels: $dependencyLevels
        impactLevels: $impactLevels
        sonLevels: $sonLevels
      ) {
        meanPhysicalNatureRisk
        meanOperationalDependencies
        meanImpactsOnNature
        meanStateOfNature
        assessedSiteCount
        highDependencySiteCount
        highImpactSiteCount
      }
    }
  }
`;

export type PortfolioRiskStatsResult = {
    organisation: {
        portfolioRiskStats: {
            meanPhysicalNatureRisk: number | null;
            meanOperationalDependencies: number | null;
            meanImpactsOnNature: number | null;
            meanStateOfNature: number | null;
            assessedSiteCount: number;
            highDependencySiteCount: number;
            highImpactSiteCount: number;
        };
    } | null;
};
